import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { postUpdateContractDataEndpoint } from '../../../common/endpoints';

export const postUpdateContractData = createApi(postUpdateContractDataEndpoint, 'POST');

const UpdateContract = createSlice({
  name: 'UpdateContract',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    updateTargetValuesData: (state, action) => {
      state.data = {
        ...state.data,
        contractDataOutputList: action.payload
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postUpdateContractData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postUpdateContractData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postUpdateContractData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const { updateTargetValuesData } = UpdateContract.actions;
export default UpdateContract.reducer;